const translations = {
  "en": {
    "Purchase failed.": "Purchase failed.",
    "Start Your 7-Day Free Trial": "Start Your 7-Day Free Trial",
    "Subscribe now": "Subscribe now",
    "Try 7 Days for Just $%{var0}": "Try 7 Days for Just $%{var0}"
  },
  "zh-tw": {
    "Purchase failed.": "購買失敗。",
    "Start Your 7-Day Free Trial": "開始你的 7 天免費試用",
    "Subscribe now": "立即訂閱",
    "Try 7 Days for Just $%{var0}": "試用 7 天僅需 $%{var0}"
  }
};

export default translations;
